import hero1 from "../assets/images/webp/hero1.webp";
import hero2 from "../assets/images/webp/hero2.webp";
import steelConstruction from "../assets/images/webp/steelConstruction-optimized.webp";
import pebService from "../assets/images/webp/pebServiceHero.webp"
import manufacture from "../assets/images/webp/manufacture.webp"
import commercial from "../assets/images/webp/commertial.webp"
import publicWorks from "../assets/images/webp/publicWork-optimized.webp"

import manufacture2 from "../assets/images/webp/manufacture2.webp"
import manufacture3 from "../assets/images/webp/manufacturei3.webp"
import commercial1 from "../assets/images/webp/commertial1.webp"
import commercial2 from "../assets/images/webp/commertial2.webp"
import commercial3 from "../assets/images/webp/commertial3.webp"
import publicWorks1 from "../assets/images/webp/publicWorks1.webp"
import publicWorks2 from "../assets/images/webp/publicWorks2.webp"
import publicWorks3 from "../assets/images/webp/publicWorks3.webp"
import publicWorks4 from "../assets/images/webp/publicWorks4.webp"
import publicWorks5 from "../assets/images/webp/publicWorks5.webp"
import publicWorks6 from "../assets/images/webp/publicWorks6.webp"
import howWorks1 from "../assets/images/webp/howWorks1.webp"
import howWorks2 from "../assets/images/webp/howWorks2.webp"
import howWorks3 from "../assets/images/webp/howWorks3.webp"
import howWorks4 from "../assets/images/webp/howWorks4.webp"
import howWorks5 from "../assets/images/webp/howWorks5.webp"
import leadingCompany1 from "../assets/images/webp/leadingCompanies1.webp"
import leadingCompany2 from "../assets/images/webp/leadingCompanies2.webp"
import leadingCompany3 from "../assets/images/webp/leadingCompanies3.webp"
import leadingCompany4 from "../assets/images/webp/leadingCompanies4.webp"
import leadingCompany5 from "../assets/images/webp/leadingCompanies5.webp"
import leadingCompany6 from "../assets/images/webp/leadingCompanies6.webp"
import logo from "../assets/images/webp/logo-optimized.webp"
import Futurebackground from "../assets/images/webp/futurebackground.webp"
import Pebbackground from "../assets/images/webp/pebbackground.webp"

import Commercialbackground from "../assets/images/webp/commerical.webp"
import Manfacture1 from "../assets/images/webp/manufacturei1-optimized.webp"
import ECSLogo from "../assets/images/webp/ecs-logo.webp";

import faq from "../assets/images/webp/faq.webp"

import structuralMain from "../assets/images/webp/structuralMain.webp"
import structuralsub from "../assets/images/webp/structuralSub.webp"

import mezzsub from "../assets/images/webp/mezzSub.webp"
import mezzmain from "../assets/images/webp/mezzMain.webp"

import multiSub from "../assets/images/webp/multiSub.webp"
import multiMain from "../assets/images/webp/multiMain.webp"

import warehouseSub from "../assets/images/webp/warehouseSub.webp"
import warehouseMain from "../assets/images/webp/warehouseMain.webp"

import composite from "../assets/images/webp/cMainandsub.webp"

import resort from "../assets/images/webp/resort-hospitality.webp"
import commericalOffice from "../assets/images/webp/commercial-officespaces.webp"
import luxuryContainerHomesHero from "../assets/images/webp/luxury-container-homes-hero.webp"
import modernHomeContainer from "../assets/images/webp/modern-home-containers.webp"
import productOverview from "../assets/images/webp/product-overview.webp"
import residentialLiving from "../assets/images/webp/residential-living.webp"

import manfacutring3 from "../assets/images/webp/manfacutring3.webp"
import manfacutring2 from "../assets/images/webp/manfacutring2.webp"
import manfacutring1 from "../assets/images/webp/manfacturing1.webp"
import pebproductOverview from "../assets/images/webp/p1.webp"
import pebhero from "../assets/images/webp/servicehero.webp"
import EPC_1 from "../assets/images/webp/EPC_1.webp"
import EPC_2 from "../assets/images/webp/EPC_2.webp"
import WarehouseandLogistics from "../assets/images/webp/WarehouseandLogistics.webp"
import ManufacturingandEngineering from "../assets/images/webp/ManufacturingandEngineering.webp"

import Notfound from "../assets/images/webp/notfound.webp"

// Randomly assign images to image1, image2, image3
// const shuffle = (array: string[]) => {
//   const shuffled = [...array];
//   for (let i = shuffled.length - 1; i > 0; i--) {
//     const j = Math.floor(Math.random() * (i + 1));
//     [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
//   }
//   return shuffled;
// };

// const [image1, image2, image3] = shuffle([img1, img2, img3]);

export const IMAGES = {
  hero1,
  hero2,
  steelConstruction,
  pebService,
  manufacture,
  commercial,
  publicWorks,
 
  manufacture2,
  manufacture3,
  commercial1,
  commercial2,
  commercial3,
  publicWorks1,
  publicWorks2,
  publicWorks3,
  publicWorks4,
  publicWorks5,
  publicWorks6,
  howWorks1,
  howWorks2,
  howWorks3,
  howWorks4,
  howWorks5,
  leadingCompany1,
  leadingCompany2,
  leadingCompany3,
  leadingCompany4,
  leadingCompany5,
  leadingCompany6,
  logo,
  Futurebackground,
  Pebbackground,
  
  Commercialbackground,
  Manfacture1,

  Notfound,
  ECSLogo,
  faq,

  structuralMain,
  structuralsub,

  mezzsub,
  mezzmain,

  multiSub,
  multiMain,

  warehouseSub,
  warehouseMain,

  composite,

  resort,
  commericalOffice,
  luxuryContainerHomesHero,
  modernHomeContainer,
  productOverview,
  residentialLiving,

  manfacutring1,
  manfacutring2,
  manfacutring3,
  pebproductOverview,
  pebhero,

  EPC_1,
  EPC_2,
  WarehouseandLogistics,
  ManufacturingandEngineering,
};

// export { image1, image2, image3 };

